var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" TBD: Link tiles "),_vm._l((_vm.$store.state.nav.linkCollection),function(item,ik){return _c('v-col',{directives:[{name:"show",rawName:"v-show",value:(item.moduleName !== 'Home'),expression:"item.moduleName !== 'Home'"}],key:ik,attrs:{"cols":"12","md":item.flex}},[_vm._v(" "+_vm._s(item)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }